import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '../../../../services/app-config.service';

@Component({
  selector: 'app-application-footer',
  templateUrl: './application-footer.component.html'
})
export class ApplicationFooterComponent implements OnInit {

  /**
   * copyright string displayed in footer
   *
   * @type {string}
   * @memberof ApplicationFooterComponent
   */
  copyRight: string;

  constructor(private appConfig: AppConfigService) { }

  ngOnInit() {
    // set year
    this.copyRight = new Date().getFullYear() + ' ' + AppConfigService.settings.copyright;
  }

}
